import React, { useState } from "react";
import { Link } from "react-router-dom";

import {
    FiGrid,
    FiList,
    FiMapPin,
    FiPackage,
    FiPhone,
    FiDownload,
    FiSend,
    FiCheckCircle,
    FiTruck,
    FiShield,
    FiAward,
    FiStar,
    FiGlobe,
    FiClock,
    FiTrendingUp,
    FiBarChart2,

    FiDroplet,
    FiSun,
    FiThermometer,
} from "react-icons/fi";

import {
    BsBasket,
    BsApple,
    BsFlower1,
    BsEmojiSunglasses,
    BsGraphUp,
    BsTruck,
    BsCalendarCheck,
    BsClipboardData,
} from "react-icons/bs";

import { RiLeafLine, RiCustomerServiceLine, RiGovernmentLine } from "react-icons/ri";
import { MdOutlineAgriculture, MdOutlineLocalShipping, MdOutlineScience } from "react-icons/md";

const Products = () => {
    const [selectedCategory, setSelectedCategory] = useState("all");
    const [viewMode, setViewMode] = useState("grid");
    const [selectedProduct, setSelectedProduct] = useState(null);

    const categories = [
        { id: "all", name: "All Products", icon: <BsBasket /> },
        { id: "mangoes", name: "Mangoes", icon: <BsApple /> },
        { id: "grapes", name: "Grapes", icon: <BsApple /> },
        { id: "pomegranates", name: "Pomegranates", icon: <BsFlower1 /> },
        { id: "oranges", name: "Oranges", icon: <RiLeafLine /> },
        { id: "bananas", name: "Bananas", icon: <BsEmojiSunglasses /> },
    ];

    const products = [
        {
            id: 1,
            name: "Alphonso Mangoes",
            category: "mangoes",
            origin: "Ratnagiri, Maharashtra",
            image:
                "p4.jfif",
            description: "King of mangoes, known for rich taste and aroma",

        },
        {
            id: 2,
            name: "Thompson Seedless Grapes",
            category: "grapes",
            origin: "Nashik, Maharashtra",

            image:
                "grapesjfif.jfif",
            description: "Sweet, crisp, and completely seedless",

        },
        {
            id: 3,
            name: "Bhagwa Pomegranates",
            category: "pomegranates",
            origin: "Solapur, Maharashtra",

            image:
                "p2.jfif",
            description: "Ruby red arils with perfect sweetness",

        },
        {
            id: 4,
            name: "Nagpur Oranges",
            category: "oranges",
            origin: "Nagpur, Maharashtra",
            image:
                "p1.jpg",
            description: "Juicy oranges with perfect sweet-tart balance",

        },
        {
            id: 5,
            name: "Robusta Bananas",
            category: "bananas",
            origin: "Tamil Nadu",

            image:
                "banana.jfif",
            description: "Fresh and nutritious bananas",

        },
    ];

    const filteredProducts =
        selectedCategory === "all"
            ? products
            : products.filter((p) => p.category === selectedCategory);

    return (
        <>
            {/* HERO SECTION WITH STATS */}
            <div
                className="position-relative text-white"
                style={{
                    background: "linear-gradient(135deg, #1a4d2e 0%, #2e7d32 100%)",
                }}
            >
                <div className="container py-5">
                    <div className="row align-items-center min-vh-50 py-5">
                        <div className="col-lg-6">
                            <h1 className="display-4 fw-bold mb-3">
                                Premium Indian Fruits for Global Export
                            </h1>
                            <p className="fs-5 mb-4 opacity-90">
                                Freshly sourced from certified farms across India.
                                Direct from farmers to your doorstep.
                            </p>

                            <div className="d-flex gap-3 flex-wrap">
                                <button className="btn btn-light px-4 py-2 fw-semibold">
                                    <FiSend className="me-2" />
                                    Export Inquiry
                                </button>

                                <Link
                                    to="/contactus"
                                    className="btn btn-outline-light px-4 py-2 fw-semibold"
                                >
                                    <FiPhone className="me-2" />
                                    Contact Us
                                </Link>

                                <button className="btn btn-outline-light px-4 py-2 fw-semibold">
                                    <FiDownload className="me-2" />
                                    Download Brochure
                                </button>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="row g-3 mt-4 mt-lg-0">
                                <div className="col-6">
                                    <div className="bg-white bg-opacity-10 rounded-3 p-3">
                                        <h3 className="h2 fw-bold mb-0">1000+</h3>
                                        <p className="mb-0 small">Happy Exporters</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="bg-white bg-opacity-10 rounded-3 p-3">
                                        <h3 className="h2 fw-bold mb-0">50+</h3>
                                        <p className="mb-0 small">Countries Served</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="bg-white bg-opacity-10 rounded-3 p-3">
                                        <h3 className="h2 fw-bold mb-0">5000+</h3>
                                        <p className="mb-0 small">Tons Exported</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="bg-white bg-opacity-10 rounded-3 p-3">
                                        <h3 className="h2 fw-bold mb-0">24/7</h3>
                                        <p className="mb-0 small">Support Available</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CATEGORY FILTER */}
            <div className="container py-5">
                <div className="d-flex flex-wrap gap-3 justify-content-center mb-4">
                    {categories.map((cat) => (
                        <button
                            key={cat.id}
                            onClick={() => setSelectedCategory(cat.id)}
                            className="btn d-flex align-items-center gap-2 px-4 py-2 rounded-pill"
                            style={{
                                background:
                                    selectedCategory === cat.id
                                        ? "#2e7d32"
                                        : "#f8f9fa",
                                color:
                                    selectedCategory === cat.id
                                        ? "#fff"
                                        : "#333",
                            }}
                        >
                            {cat.icon}
                            {cat.name}
                        </button>
                    ))}
                </div>

                {/* VIEW TOGGLE AND RESULTS COUNT */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p className="text-muted mb-0">
                        Showing {filteredProducts.length} products
                    </p>
                    <div className="d-flex gap-2">
                        <button
                            onClick={() => setViewMode("grid")}
                            className={`btn ${viewMode === "grid" ? "btn-success" : "btn-light"}`}
                        >
                            <FiGrid />
                        </button>
                        <button
                            onClick={() => setViewMode("list")}
                            className={`btn ${viewMode === "list" ? "btn-success" : "btn-light"}`}
                        >
                            <FiList />
                        </button>
                    </div>
                </div>

                {/* PRODUCTS */}
                <div className="row g-4">
                    {filteredProducts.map((product) => (
                        <div
                            key={product.id}
                            className={viewMode === "grid" ? "col-md-6 col-lg-4" : "col-12"}
                        >
                            <div className="card h-100 shadow-sm border-0 hover-shadow transition">
                                <div className="position-relative">
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="card-img-top"
                                        style={{ height: "250px", objectFit: "cover" }}
                                    />

                                </div>

                                <div className="card-body">
                                    <h5 className="fw-bold mb-2">{product.name}</h5>

                                    <div className="d-flex align-items-center text-muted small mb-2">
                                        <FiMapPin className="me-1 flex-shrink-0" />
                                        <span>{product.origin}</span>
                                    </div>

                                    <p className="small text-muted mb-3">{product.description}</p>









                                    <div className="d-flex gap-2">
                                        <button className="btn btn-success flex-grow-1">
                                            <FiPhone className="me-2" />
                                            Inquire Now
                                        </button>
                                        {/* <button 
                      className="btn btn-outline-success"
                      onClick={() => setSelectedProduct(product)}
                      data-bs-toggle="modal"
                      data-bs-target="#productModal"
                    >
                      Details
                    </button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* QUALITY STANDARDS SECTION */}
            <div className="bg-light py-5">
                <div className="container">

                    <div className="text-center mb-5">
                        <h2 className="fw-bold mb-3">
                            Our Quality Standards
                        </h2>
                        <p className="text-muted">
                            Committed to delivering the finest quality fruits globally
                        </p>
                    </div>

                    <div className="row g-4">

                        {[
                            { icon: <FiShield size={30} />, title: "GlobalG.A.P.", subtitle: "Certified" },
                            { icon: <FiAward size={30} />, title: "ISO 22000", subtitle: "Food Safety" },
                            { icon: <FiStar size={30} />, title: "Organic", subtitle: "Certified" },
                            { icon: <FiStar size={30} />, title: "Premium Grade", subtitle: "Export Quality" }
                        ].map((item, index) => (

                            <div className="col-md-3 col-6" key={index}>
                                <div
                                    className="bg-white h-100 text-center p-4 shadow-sm"
                                    style={{
                                        borderRadius: "20px",
                                        transition: "0.3s",
                                        cursor: "pointer"
                                    }}
                                >

                                    {/* Icon Circle */}
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center mb-3"
                                        style={{
                                            width: "70px",
                                            height: "70px",
                                            borderRadius: "50%",
                                            background: "linear-gradient(135deg, #198754, #20c997)",
                                            color: "#fff"
                                        }}
                                    >
                                        {item.icon}
                                    </div>

                                    <h6 className="fw-bold mb-1">
                                        {item.title}
                                    </h6>

                                    <small className="text-muted">
                                        {item.subtitle}
                                    </small>

                                </div>
                            </div>

                        ))}

                    </div>
                </div>
            </div>


            {/* EXPORT PROCESS SECTION */}
            <div className="py-5">
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* LEFT SIDE */}
                        <div className="col-lg-6">

                            <h2 className="fw-bold mb-3">
                                Our Export Process
                            </h2>

                            <p className="text-muted mb-5">
                                From farm to port, we ensure the highest quality standards at every step.
                            </p>

                            {[
                                {
                                    no: "01",
                                    title: "Farm Selection & Harvesting",
                                    desc: "Partnering with certified farms for premium quality produce"
                                },
                                {
                                    no: "02",
                                    title: "Grading & Sorting",
                                    desc: "Strict quality checks and size grading"
                                },
                                {
                                    no: "03",
                                    title: "Packaging & Cold Storage",
                                    desc: "Export-ready packaging and temperature-controlled storage"
                                },
                                {
                                    no: "04",
                                    title: "Logistics & Documentation",
                                    desc: "Hassle-free shipping and complete export documentation"
                                }
                            ].map((step, index) => (
                                <div key={index} className="d-flex align-items-start mb-4">

                                    {/* Number Circle */}
                                    <div
                                        className="flex-shrink-0 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "55px",
                                            height: "55px",
                                            borderRadius: "50%",
                                            background: "linear-gradient(135deg, #198754, #20c997)",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            fontSize: "1rem"
                                        }}
                                    >
                                        {step.no}
                                    </div>

                                    {/* Content */}
                                    <div className="ms-4">
                                        <h6 className="fw-bold mb-1">{step.title}</h6>
                                        <p className="text-muted mb-0 small">
                                            {step.desc}
                                        </p>
                                    </div>

                                </div>
                            ))}

                        </div>

                        {/* RIGHT SIDE IMAGE */}
                        <div className="col-lg-6 text-center">
                            <img
                                src="ex.png"
                                alt="Export Process"
                                className="img-fluid rounded-4 shadow-lg"
                                style={{
                                    maxHeight: "420px",
                                    objectFit: "cover"
                                }}
                            />
                        </div>

                    </div>
                </div>
            </div>


            {/* CLIENT TESTIMONIALS */}
            <div className="bg-light py-5">
                <div className="container">
                    <h2 className="fw-bold text-center mb-5">What Our Global Clients Say</h2>

                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="bg-white p-4 rounded-3 shadow-sm">
                                <div className="d-flex gap-1 text-warning mb-3">
                                    {[...Array(5)].map((_, i) => (
                                        <FiStar key={i} fill="currentColor" />
                                    ))}
                                </div>
                                <p className="small mb-3">
                                    "Excellent quality Alphonso mangoes! The packaging and timely delivery exceeded our expectations."
                                </p>
                                <div className="d-flex align-items-center">
                                    <div className="bg-success rounded-circle text-white d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                                        <span className="fw-bold">AJ</span>
                                    </div>
                                    <div className="ms-3">
                                        <h6 className="mb-0 small fw-bold">Ahmed Al-Rashid</h6>
                                        <small className="text-muted">Dubai, UAE</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="bg-white p-4 rounded-3 shadow-sm">
                                <div className="d-flex gap-1 text-warning mb-3">
                                    {[...Array(5)].map((_, i) => (
                                        <FiStar key={i} fill="currentColor" />
                                    ))}
                                </div>
                                <p className="small mb-3">
                                    "Consistent supply of premium grapes throughout the season. Great partnership!"
                                </p>
                                <div className="d-flex align-items-center">
                                    <div className="bg-success rounded-circle text-white d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                                        <span className="fw-bold">MJ</span>
                                    </div>
                                    <div className="ms-3">
                                        <h6 className="mb-0 small fw-bold">Michael Johnson</h6>
                                        <small className="text-muted">London, UK</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="bg-white p-4 rounded-3 shadow-sm">
                                <div className="d-flex gap-1 text-warning mb-3">
                                    {[...Array(5)].map((_, i) => (
                                        <FiStar key={i} fill="currentColor" />
                                    ))}
                                </div>
                                <p className="small mb-3">
                                    "Their pomegranates are simply the best we've imported. Excellent customer support!"
                                </p>
                                <div className="d-flex align-items-center">
                                    <div className="bg-success rounded-circle text-white d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                                        <span className="fw-bold">LW</span>
                                    </div>
                                    <div className="ms-3">
                                        <h6 className="mb-0 small fw-bold">Li Wei</h6>
                                        <small className="text-muted">Singapore</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ SECTION */}
            <div className="py-5">
                <div className="container">
                    <h2 className="fw-bold text-center mb-5">Frequently Asked Questions</h2>

                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="border rounded-3 p-4 h-100">
                                <h6 className="fw-bold mb-3">What is the minimum order quantity?</h6>
                                <p className="small text-muted mb-0">
                                    Minimum order quantity varies by product, typically starting from 500 kg for most fruits. Contact us for specific requirements.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded-3 p-4 h-100">
                                <h6 className="fw-bold mb-3">Do you provide samples?</h6>
                                <p className="small text-muted mb-0">
                                    Yes, we can arrange samples for serious buyers. Shipping charges may apply.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded-3 p-4 h-100">
                                <h6 className="fw-bold mb-3">What are your payment terms?</h6>
                                <p className="small text-muted mb-0">
                                    We offer flexible payment terms including Letter of Credit (L/C), Telegraphic Transfer (T/T), and other mutually agreeable terms.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded-3 p-4 h-100">
                                <h6 className="fw-bold mb-3">How do you ensure quality?</h6>
                                <p className="small text-muted mb-0">
                                    We follow strict quality control measures at every stage, from farm selection to packaging, with international certifications.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA BANNER */}
            <div className="bg-success text-white py-5">
                <div className="container text-center">
                    <h2 className="fw-bold mb-3">Ready to Start Exporting?</h2>
                    <p className="fs-5 mb-4 opacity-90">
                        Join hundreds of satisfied global importers who trust us for premium Indian fruits
                    </p>
                    <div className="d-flex gap-3 justify-content-center">
                        <button className="btn btn-light px-4 py-2 fw-semibold">
                            <FiSend className="me-2" />
                            Send Inquiry
                        </button>
                        <Link
                            to="/contactus"
                            className="btn btn-outline-light px-4 py-2 fw-semibold"
                        >
                            <FiPhone className="me-2" />
                            Contact Sales
                        </Link>
                    </div>
                </div>
            </div>

            {/* Product Details Modal */}
            <div className="modal fade" id="productModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <h5 className="modal-title fw-bold">{selectedProduct?.name}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            {selectedProduct && (
                                <div className="row">
                                    <div className="col-md-6">
                                        <img
                                            src={selectedProduct.image}
                                            alt={selectedProduct.name}
                                            className="img-fluid rounded-3 mb-3"
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <h6 className="fw-bold mb-2">Product Specifications</h6>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="text-muted">Origin</td>
                                                    <td className="fw-bold">{selectedProduct.origin}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">Season</td>
                                                    <td className="fw-bold">{selectedProduct.season}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">Size</td>
                                                    <td className="fw-bold">{selectedProduct.specifications.size}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">Color</td>
                                                    <td className="fw-bold">{selectedProduct.specifications.color}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">Shelf Life</td>
                                                    <td className="fw-bold">{selectedProduct.specifications.shelfLife}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">MOQ</td>
                                                    <td className="fw-bold">{selectedProduct.minOrder}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <h6 className="fw-bold mb-2 mt-3">Certifications</h6>
                                        <div className="d-flex gap-2 flex-wrap mb-3">
                                            {selectedProduct.certifications.map((cert, idx) => (
                                                <span key={idx} className="badge bg-success bg-opacity-10 text-success p-2">
                                                    {cert}
                                                </span>
                                            ))}
                                        </div>

                                        <h6 className="fw-bold mb-2">Export Destinations</h6>
                                        <div className="d-flex gap-2 flex-wrap">
                                            {selectedProduct.exportDestinations.map((dest, idx) => (
                                                <span key={idx} className="badge bg-light text-dark p-2">
                                                    {dest}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer border-0">
                            <button className="btn btn-success" data-bs-dismiss="modal">
                                <FiPhone className="me-2" />
                                Inquire Now
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
        .hover-shadow {
          transition: all 0.3s ease;
        }
        .hover-shadow:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
        }
        .opacity-90 {
          opacity: 0.9;
        }
        .min-vh-50 {
          min-height: 50vh;
        }
      `}</style>
        </>
    );
};

export default Products;